import { useContactFormStore } from '../store/contactFormStore';
import { IFormSubmit, IFormSubmitWithRecaptcha, IFormSubmitPayload } from '../utils/interfaces';

declare const grecaptcha: {
  enterprise: {
    execute: (siteKey: string, options: { action?: string }) => Promise<string>;
  };
};

const getSiteMarket = (): string => {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  return pathSegments.length >= 2 ? `${pathSegments[0]}/${pathSegments[1]}` : '';
}

const addConfigsToPayload = (payload: IFormSubmitWithRecaptcha, formPath: string, templatePath: string, market: string, siteMarket: string): IFormSubmitPayload => {
  return {
    ...payload,
    form_path: formPath,
    template_path: templatePath,
    market, 
    siteMarket
  } as IFormSubmitPayload;
}

const sendToApi = (payload: IFormSubmitPayload, url: string): Promise<Response> => {
  return fetch(url, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  });
}

export const useSubmitForm = () => {
  const contactFormStore = useContactFormStore();
  const formPath = contactFormStore.getFormConfigurationPath ?? '';
  const templatePath = contactFormStore.getFormTemplatePath ?? '';
  const apiEndpoint = contactFormStore.getFormProcessorApiEndPoint ?? '';
  const market = contactFormStore.getMarket ?? '';
  const siteMarket = getSiteMarket();

  const onSubmitForm = (payload: IFormSubmit): void => {
    grecaptcha.enterprise.execute(contactFormStore.getRecaptchaSiteKey, { action: contactFormStore.getRecaptchaActionWord })
      .then((recaptchaResponse) => {
        const payloadWithRecaptcha: IFormSubmitWithRecaptcha = {
          ...payload,
          'g-recaptcha-response': recaptchaResponse,
          'site-key': contactFormStore.getRecaptchaSiteKey
        };

        const finalPayload: IFormSubmitPayload = addConfigsToPayload(payloadWithRecaptcha, formPath, templatePath, market, siteMarket);
        return sendToApi(finalPayload, apiEndpoint);
      })
      .then((response) => {
        contactFormStore.updateFormStatus(!response.ok)
      })
      .catch(() => {
        contactFormStore.updateFormStatus(true);
      });
  };

  return { onSubmitForm };
};
